import {createReducer} from '../../../utils/reducer';
import User from '../actions/User';

export default createReducer(null, {
    [User.update]: (state, data) => data,
});



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/user.js